import React, { useState, useEffect } from 'react';

import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const ModernHeader = ({ tenant, selectedCity, onCitySelect, onShowTicketModal, locationLoading, locationError, onDetectLocation }) => {
  const [cities, setCities] = useState([]);
  
  useEffect(() => {
    fetchCities();
  }, []);
  
  const fetchCities = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/public/cities`);
      if (response.data.success) {
        setCities(response.data.cities.map(city => ({
          id: city.toLowerCase(),
          name: city.charAt(0).toUpperCase() + city.slice(1)
        })));
      }
    } catch (error) {
      // Fallback to tickets data
      try {
        const ticketsResponse = await axios.get(`${API_BASE_URL}/api/public/test-tickets`);
        if (ticketsResponse.data.success) {
          const uniqueCities = [...new Set(ticketsResponse.data.tickets.map(t => t.city))].sort();
          setCities(uniqueCities.map(city => ({
            id: city.toLowerCase(),
            name: city.charAt(0).toUpperCase() + city.slice(1)
          })));
        }
      } catch (dbError) {
        console.error('Error fetching cities:', dbError);
      }
    }
  };
  
  const getCityName = (cityId) => {
    const city = cities.find(c => c.id === cityId);
    return city ? city.name : 'Detecting...';
  };
  

  const [citySearch, setCitySearch] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const filteredCities = cities.filter(city => 
    city.name.toLowerCase().includes(citySearch.toLowerCase())
  );
  
  const handleCitySelect = (cityId) => {
    onCitySelect(cityId);
    setCitySearch('');
    setShowSuggestions(false);
  };
  
  // Clear search when selectedCity changes
  useEffect(() => {
    setCitySearch('');
    setShowSuggestions(false);
  }, [selectedCity]);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.city-search-container')) {
        setShowSuggestions(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header style={{
      background: 'linear-gradient(135deg, #06b6d4 0%, #10b981 100%)',
      color: 'white',
      padding: '0',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      backdropFilter: 'blur(10px)',
      boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
    }}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={{ 
        maxWidth: '1400px', 
        margin: '0 auto', 
        padding: window.innerWidth <= 768 ? '0 16px' : '0 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: window.innerWidth <= 768 ? '70px' : '80px',
        flexWrap: window.innerWidth <= 480 ? 'wrap' : 'nowrap'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}>
            <img 
              src="/Logo1.png" 
              alt="Tiket Jini Logo" 
              style={{
                width: window.innerWidth <= 768 ? '60px' : '70px',
                height: window.innerWidth <= 768 ? '60px' : '70px',
                borderRadius: '12px',
                objectFit: 'cover',
                minWidth: '50px',
                cursor: 'pointer'
              }}
            />
          </a>
          <div style={{ display: window.innerWidth <= 480 ? 'none' : 'block' }}>
            <h2 style={{ margin: 0, fontSize: window.innerWidth <= 768 ? '20px' : '28px', fontWeight: '700', letterSpacing: '-0.5px' }}>
              Tiket Jini
            </h2>
            <p style={{ margin: 0, fontSize: window.innerWidth <= 768 ? '12px' : '14px', opacity: 0.8, fontWeight: '400', display: window.innerWidth <= 768 ? 'none' : 'block' }}>
              Book Amazing Sites & Services
            </p>
          </div>
        </div>
        
        <nav style={{ display: 'flex', gap: window.innerWidth <= 768 ? '8px' : '12px', alignItems: 'center', flexWrap: 'wrap' }}>
          {/* City Search */}
          <div className="city-search-container" style={{ position: 'relative' }}>
            <input
              type="text"
              placeholder={selectedCity ? getCityName(selectedCity) : "Search city..."}
              value={citySearch}
              onChange={(e) => {
                setCitySearch(e.target.value);
                setShowSuggestions(true);
              }}
              onFocus={() => setShowSuggestions(true)}
              style={{
                background: 'rgba(255,255,255,0.9)',
                border: '1px solid rgba(255,255,255,0.3)',
                color: '#2d3748',
                padding: window.innerWidth <= 768 ? '8px 35px 8px 12px' : '10px 40px 10px 16px',
                borderRadius: '25px',
                fontSize: window.innerWidth <= 768 ? '12px' : '14px',
                width: window.innerWidth <= 768 ? '140px' : '200px',
                outline: 'none',
                backdropFilter: 'blur(10px)'
              }}
            />
            <button
              onClick={onDetectLocation}
              disabled={locationLoading}
              title={locationError || (locationLoading ? 'Detecting location...' : 'Detect my location')}
              style={{
                position: 'absolute',
                right: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: locationError ? 'rgba(239, 68, 68, 0.2)' : 'none',
                border: 'none',
                color: locationError ? '#dc2626' : 'white',
                cursor: locationLoading ? 'not-allowed' : 'pointer',
                fontSize: '16px',
                opacity: locationLoading ? 0.7 : 1,
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                if (!locationLoading && !locationError) {
                  e.target.style.background = 'rgba(255,255,255,0.2)';
                }
              }}
              onMouseOut={(e) => {
                if (!locationError) {
                  e.target.style.background = 'none';
                }
              }}
            >
              {locationLoading ? (
                <div style={{
                  width: '12px',
                  height: '12px',
                  border: '2px solid white',
                  borderTop: '2px solid transparent',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }} />
              ) : locationError ? '⚠️' : '📍'}
            </button>
            
            {/* City Suggestions */}
            {showSuggestions && filteredCities.length > 0 && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                background: 'white',
                borderRadius: '12px',
                boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                zIndex: 1000,
                marginTop: '4px',
                maxHeight: '200px',
                overflowY: 'auto'
              }}>
                {filteredCities.map(city => (
                  <div
                    key={city.id}
                    onClick={() => handleCitySelect(city.id)}
                    style={{
                      padding: '12px 16px',
                      cursor: 'pointer',
                      color: '#2d3748',
                      borderBottom: '1px solid #e2e8f0',
                      transition: 'background 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.background = '#f7fafc'}
                    onMouseOut={(e) => e.target.style.background = 'white'}
                  >
                    📍 {city.name}
                  </div>
                ))}
              </div>
            )}
          </div>
          <button
            onClick={onShowTicketModal}
            style={{
              background: 'linear-gradient(45deg, #48bb78, #38a169)',
              color: 'white',
              border: 'none',
              padding: window.innerWidth <= 768 ? '8px 12px' : '10px 20px',
              borderRadius: '25px',
              cursor: 'pointer',
              fontSize: window.innerWidth <= 768 ? '12px' : '14px',
              fontWeight: '600',
              boxShadow: '0 4px 15px rgba(72,187,120,0.3)'
            }}
          >
            📱 My Tickets
          </button>
        </nav>
      </div>
    </header>
  );
};

export default ModernHeader;